__turbopack_context__.v({
  "closure": "Footer-module-scss-module__Erf6DW__closure",
  "closureLinks": "Footer-module-scss-module__Erf6DW__closureLinks",
  "columns": "Footer-module-scss-module__Erf6DW__columns",
  "footer": "Footer-module-scss-module__Erf6DW__footer",
  "link": "Footer-module-scss-module__Erf6DW__link",
  "links": "Footer-module-scss-module__Erf6DW__links",
  "logo": "Footer-module-scss-module__Erf6DW__logo",
  "title": "Footer-module-scss-module__Erf6DW__title",
  "workspaceLogo": "Footer-module-scss-module__Erf6DW__workspaceLogo",
});
